var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25,9a1.125,1.125,0,0,0,0,2.25h3.375a3.375,3.375,0,0,1,0,6.75H4.908c.306-.348.679-.795,1.055-1.294.221-.3.45-.619.668-.956h7.995a1.125,1.125,0,0,0,0-2.25H11.25a3.375,3.375,0,1,1,0-6.75h1.48a6.663,6.663,0,0,1-1.48-3.375,3.375,3.375,0,0,1,6.75,0C18,5.625,14.625,9,14.625,9Zm3.375-4.5A1.125,1.125,0,1,0,13.5,3.375,1.124,1.124,0,0,0,14.625,4.5ZM4.159,17.149l-.021.021c-.151.176-.288.327-.4.45a.421.421,0,0,0-.039.042c-.2.214-.323.337-.323.337S0,14.625,0,12.375a3.375,3.375,0,1,1,6.75,0A6.663,6.663,0,0,1,5.27,15.75c-.415.534-.78,1.016-1.111,1.4ZM3.343,13.5a1.125,1.125,0,1,0,0-2.25,1.125,1.125,0,1,0,0,2.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoute);
export default __webpack_public_path__ + "static/media/icon_route.d8d8e17bc7f49fe3515b509f986ff334.svg";
export { ForwardRef as ReactComponent };